<template>
  <div class="home">
    WageCalendar : 달력형 알바비 계산기<br>
    MyPage : 마이페이지
  </div>
</template>

<script>
import { getCurrentInstance } from '@vue/runtime-core';
export default {
  data() {
    return {
      app:"",
      socket:"",
    }
  },
  created() {
    this.app = getCurrentInstance();
    this.socket = this.app.appContext.config.globalProperties.$socket;
    // try {
    //   this.socket.send('{event:"loginCheck"}');
    // } catch (error) {
    //   console.error(error)
    // }
  },
}
</script>

<style>

</style>